import { appendChatDesk } from '@amarkets/atlas/esm/lib/append-chat-desk';
import FacadeGlobal from '@/plugins/store/facades/facade-global';
import { initRefiner } from './init-refiner';

export function initThirdParty({ store, i18n, isWebview }) {
  const runIdle = (cb) => {
    if ('requestIdleCallback' in window) {
      (window).requestIdleCallback(cb);
    } else {
      setTimeout(cb, 1000);
    }
  };

  runIdle(() => {
    const isProductionEnv = import.meta.env.VITE_ENV === 'production';
    const facadeGlobal = new FacadeGlobal(store);
    const userProfile = facadeGlobal.userProfile();
    const userId = facadeGlobal.getUserUid();
    const isMtWebPage = /\/mt-web(\/|$)/.test(new URL(window.location.href).pathname);
    const isChatDeskEnabled = import.meta.env.VITE_ENV !== 'development' && !isWebview && !isMtWebPage;

    if (isProductionEnv) {
      initRefiner({ userUid: userId, userProfile });
    }

    if (isChatDeskEnabled) {
      const userCountry = facadeGlobal.getUserCountry();
      const walletId = facadeGlobal.getUserWalletId();

      const userDataForChatToDesk = {
        email: userProfile.email,
        name: userProfile.fullName,
        phone: facadeGlobal.getUserData().phoneNumber,
        isoCodeCountry: userCountry,
        isGoldStatus: userProfile.isGoldStatus,
        hasPayments: userProfile.officeHasPayments,
        managerId: userProfile.personalManager?.id || null,
        userId,
        walletId,
      };

      appendChatDesk({
        clientInfo: userDataForChatToDesk,
        faqLink: i18n.global.t('common.faq'),
      });
    }
  });
}
